export default {
  submenu: 'Untermenü:',
  content: 'Inhalt',
  overview: 'Übersicht',
  longTermSupport: 'Langzeitunterstützung',
  skillsAndTalents: 'Fähigkeiten und Talente',
  yourMap: 'Ihre Karte',
  motivationAndEmotionalIntelligence: 'Motivation und emotionale Intelligenz',
  alliancesCompromisesAndResources: 'Allianzen, Kompromisse und Ressourcen',
  skillsToStartABusiness: 'Fähigkeiten, um ein Unternehmen zu gründen',
  accountingAndFinance: 'Kontoführung und Finanzen',
  settingUpYourOwnBusiness: 'Ein eigenes Unternehmen gründen',
  accountingBasics: 'Grundlagen der Rechnungslegung',
  openingABankAccount: 'Eröffnung eines Bankkontos',
  businessPlanBasicInformation: 'Business Plan, Grundinformationen',
  taxes: 'Steuern',
  legalFormsOfEmployment: 'Rechtsformen der Beschäftigung',
  marketingAndSales: 'Marketing & Vertrieb',
  whatAreMyProducts: 'Welche Produkte möchte ich anbieten?',
  whoAreMyClients: 'Wer sind meine Kunden?',
  communication: 'Kommunikation',
  positioning: 'Positionierung',
  sales: 'Vertrieb',
  uniqueSellingPoints: 'Alleinstellungsmerkmale',
  publicRelations: 'Öffentlichkeitsarbeit',
  introduction: 'Einführung',
  strategy: 'Strategie',
  messagesAndTools: 'Nachrichten und Werkzeuge',
  digitalPRAndSMRevolution: 'Digitale PR and SM Revolution',
  it: 'IT',
  cloudVSOnPremises: 'Cloud vs. On-Premises',
  email: 'E-Mail',
  onlineMarketing: 'Online Marketing',
  webshop: 'Webshop',
  website: 'Webseite'
}



// WEBPACK FOOTER //
// ./src/i18n/contentnav/de.js